import React, { Component } from 'react';

import { MyInput } from '../elements/MyInput';

import { DropdownWithUrl } from '../elements/DropdownWithUrl'
import {FileUploader} from '../elements/FileUploader'

import {BlacklistTable} from '../tables/blacklist/BlacklistTable'
export class Block extends Component {
  constructor(props) {
    super(props);
    this.state = { currentCount: 0, isLoading: false };
    this.state.data = {};
    //  this.incrementCounter = this.incrementCounter.bind(this);
    /*
    this.onFormChange = this.onFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.onPrizeClick = this.onPrizeClick.bind(this);
    this.onGhoreClick = this.onGhoreClick.bind(this);

    this.onHideMasterPage = this.onHideMasterPage.bind(this);

    this.onAddCeremony=this.onAddCeremony.bind(this);
*/

    this.onTextChange=this.onTextChange.bind(this);
    this.onFileChange=this.onFileChange.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
    var token = localStorage.getItem('token');
    this.headers =
    {
      'Content-Type': 'application/json',
      'AuthorizationToken': token
    };

    this.header =
    {
   //   'Content-Type': 'application/json',
      'AuthorizationToken': token
    };
  }

  handleSubmit(e)
  {
  e.preventDefault();

    var data = new FormData() ;
    data.append('file', this.state.data.selectedFile);
    data.append('ghoreId',this.state.data.ghoreId);
    
    console.log(data);
    console.log(this.state.data.ghoreId);
    fetch('api/v1/Block',
    {
        method: 'POST',
        body: data,
        headers: this.header
    }).then(res => {
        this.status = res.status;


        if (this.status === 401) {
            localStorage.setItem('token', null);
            window.location.reload(false);

        }

        res.json().then((result) => {

            //      console.log("status:" + this.status);

            if (this.status === 200) {

                //   console.log(result);
                //  this.state.reverseChances = result;

                alert("با موفقیت انجام شد");
                this.state.isLoaded = true;
                this.setState({ reverseChances: result });

                //    console.log(this.state.reverseChances);

            }
            else 
            {
              console.log(result);
                 alert(result.Value);
                //    this.setState({});
                //window.location.href = "/ghorekeshi";
            }

        },
            (error) => {

            }
        );
    }
    );
  }

  onTextChange(data,key)
  {

    this.state.data[key]=data;
  }

  onFileChange(key,file)
  {
    this.state.data.selectedFile=file;
  }



  render() {

    return (
      <div >



        <hr />

        <div className="row">
          <div className="col-md-4">
          </div>
          <div className="col-md-4 col-sm-12">

            <form className="" onSubmit={this.handleSubmit} ref="myRef">
            
              <DropdownWithUrl label=" قرعه کشی" name="ghoreId" onChange={this.onTextChange} headers={this.headers} url={"/api/v1/GetBreifGhore"} />                    
              <br />
              <FileUploader onFileChange={this.onFileChange} />
              <br/>
        
              <hr/>

              <div className="row col-sm-12">
              <div className=" col-sm-6">
                  <button className="btn btn-primary  btn-block btn-flat" >حذف کردن</button>
              </div>
              <div className=" col-sm-6">
              <a href="/Report/Book2.xlsx" target="_blank">نمونه فایل</a> 

              </div>
             
              <br/>
              </div>
     
          
            </form>
          </div>
          <div className="col-md-4">
          </div>


        </div>
      <hr/>
      <h2>
      گزارش حذفیات
      </h2>
      <hr/>
        <BlacklistTable/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Block.js